import React, { useEffect, useState } from 'react'
import { Box, Button, Title, Flex, Card, Skeleton, Grid, SegmentedControl } from '@mantine/core'
import PlansTable from '../components/Plans/Table'
import ModalPlans from '../components/Plans/Modal'
import { usePlanStore } from '../store/usePlanStore'

const Plans = () => {
  const { plans, loading, getPlanList, deletePlan } = usePlanStore();
  const [item, setItem] = useState(null)
  const [isOpen, setIsOpen] = useState(false);
  const [contractFilter, setContractFilter] = useState('Todos');
  const [filteredPlans, setFilteredPlans] = useState([]);

  useEffect(() => {
    getPlanList();
  }, [])

  useEffect(() => {
    if (contractFilter === 'Todos') {
      setFilteredPlans(plans);
    } else {
      // Fallback to 'Postpago' for legacy plans without the field
      setFilteredPlans(plans.filter(p => (p.type_contract || 'Postpago') === contractFilter));
    }
  }, [plans, contractFilter]);

  const onOpen = (item) => {
    setIsOpen(true);
    setItem(item);
  }
  const onClose = () => {
    setIsOpen(false);
    setItem(null);
  }

  return (
    <>
      <Box className='w-full gap-1 h-[100vh] py-2 px-2'>
        <Flex direction={{ base: 'column', md: 'row' }} justify="space-between" px="md" pb="lg" align="center" gap="md">
          <Box>
            <Title order={1} >Gestión de Planes</Title>
            <Title order={ 5 } fw={ 400 } c="dimmed">Administra los abonos y velocidades del servicio</Title>
          </Box>
          
          <Flex align="center" gap="md" direction={{ base: 'column', sm: 'row' }} w={{ base: '100%', md: 'auto' }}>
            <SegmentedControl
              value={contractFilter}
              onChange={setContractFilter}
              color="yellow"
              size="md"
              data={['Todos', 'Prepago', 'Postpago']}
              w={{ base: '100%', sm: 'auto' }}
            />
            <Button size="md" onClick={() => onOpen(null)}>Nuevo Plan</Button>
          </Flex>
        </Flex>

        <Box className='w-full py-1 rounded flex flex-col items-center justify-center'>
          {!loading ? (
            <PlansTable items={filteredPlans} onOpen={onOpen} remove={deletePlan} />
          ) : (
            <Card shadow="md" p="xl" withBorder mx="md" w="100%">
              <Grid w="100%">
                {[1, 2, 3, 4, 5, 6, 7].map(i => (
                  <Skeleton key={i} height={60} radius="md" my="xs" />
                ))}
              </Grid>
            </Card>
          )}
        </Box>
      </Box>
      <ModalPlans isOpen={isOpen} onClose={onClose} item={item} />
    </>
  )
}

export default Plans
